// import CountryIcon from 'components/common/CountryIcon';
import {
    Box,
    IconButton,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Button
} from '@chakra-ui/react';
import {find} from 'lodash';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import CountryIcon from './CountryIcon';
import {ChevronDownIcon} from '@chakra-ui/icons';
import { useAuthStore } from 'stores/authStore';

const LanguageBtn = (props) => {
    const {noShadow, small=true} = props;
    const {t, i18n} = useTranslation('app');
    const [language, setLanguage] = useAuthStore(state=>[state.language, state.setLanguage])

    const languageList = [
        {
            label: t('englishConsist'),
            value: 'en-US',
            county: 'US',
            shortLabel: 'EN',
        },
        {
            label: t('chineseConsist'),
            value: 'zh-CN',
            county: 'CN',
            shortLabel: '简中',
        },
        {
            label: t('chineseTWConsist'),
            value: 'zh-TW',
            county: 'CN',
            shortLabel: '繁中',
        },
        {
            label: t('japaneseConsist'),
            value: 'jp-JP',
            county: 'JP',
            shortLabel: '日本語',
        },
        {
            label: t('koreanConsist'),
            value: 'ko-KR',
            county: 'kr',
            shortLabel: '한국',
        },
        // {
        //     label: t('thailandConsist'),
        //     value: 'th-TH',
        //     county: 'TH',
        //     shortLabel: 'แบบไทย',
        // },
        // {
        //     label: t('vietnamConsist'),
        //     value: 'vi-VN',
        //     county: 'VN',
        //     shortLabel: 'Tiếng Việt',
        // },
    ];
    const matched = find(languageList, (o) => o.value === language);
    return (
        <Menu>
            <MenuButton
                size={'sm'}
                // border={'1px'}
                // borderColor={'gray.100'}
                as={Button}
                aria-label="Options"
                // rightIcon={small ? null : <ChevronDownIcon />}
                // leftIcon={
                //     small ? null : (
                //         <CountryIcon country={matched.county} size={24} />
                //     )
                // }
                boxShadow={'none'}
                variant={'ghost'}
                // bg={'white'}
                px={small ? 1 : 4}
            >
                {matched.shortLabel}
            </MenuButton>
            <MenuList >
                {languageList.map((item) => (
                    <MenuItem
                        fontSize={ 'sm'}
                        fontWeight={'500'}
                        onClick={() => { i18n.changeLanguage(item.value); setLanguage(item.value) }}
                        key={item.value}
                        // icon={<CountryIcon country={item.county} size={24} />}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
};

export default LanguageBtn;
